module.exports = __webpack_public_path__ + "static/media/wallet-guide-mobile-1.a59952b7.png";